module.exports = __webpack_public_path__ + "img/11.694e7e55.jpg";